import React from "react";
import "./App.css";

// components
import Header from "./components/Header";
import Skills from "./components/Skills";
import About from "./components/About";
import ProjectView from "./components/ProjectView";

import Nav from "./components/Nav";

function App() {
   return (
      <div className="App">

         <Header />

         <div className="app__fade1" />

         <About />

         <Skills id="skills" />

         <div className="app__fade1" />

         <div id="projects" style={{ textAlign: "center" }}>
            <h1>Personal Projects</h1>
         </div>

         <ProjectView />

         <Nav />
         <div style={{ height: 100 }} />
      </div>
   );
}

export default App;
